{
  "en": {
    "published": {
      "labels": {
        "publishedCustomerPartners": "Published for customers & partners",
        "publishedCustomer": "Published for customers",
        "publishedPartners": "Published for partners",
        "notPublished": "Not published"
      }
    }
  }
}
